module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Chapter Three")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola left the newsroom at five that day, something no self-respecting reporter ever did, counting down the hours to the aunties’ ultimatum.  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Seven hours until midnight. Another eleven until her deadline. Eighteen to come up with a reason not to go to Utah, one that would persuade Alice and the other elders that she’d really turned the corner. Or would. Soon. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She turned off the main road out of Magpie and onto the long gravel lane that led up to the house, scanning the surrounding prairie for the black-and-white streak racing to meet her pickup. No Bub. He must be in the house with Margaret. But when she pulled up, Bub lay on the porch surveying his kingdom, unmoving, not so much as a twitch of his tail. Even Spot, their aging appaloosa, turned his freckled rump when Lola got out of the truck, finding urgent business on the other side of the corral.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola hefted a bag of take-out, stomped up the steps and waited, willing the dog to leap up as he’d once done, to dance on his hind legs, bracing his forepaws against her, swiping her chin with his tongue between ecstatic yips of greeting. But Bub only stretched his jaws stretched wide in an extravagant yawn. In the corral, Spot lowered himself to his knees, then rolled onto his back, hooves in the air, grunting in the luxury of a roll in the dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola knew humans who were less effective at communicating disdain. “To hell with both of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She took a second at the door to assume the barely remembered posture of someone with purpose, before going inside and offering fulsome thanks—and an extra five bucks—to Ruthie Kicking Woman, Alice’s great-grand-something, the high school student who’d been designated Margaret’s after-school sitter for the day. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ruthie shoved a brick-thick book into her bag and scooped some hieroglyphic-covered papers in behind it. “We played a new game today.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s that?” Lola directed the question at Margaret. Her daughter was at the table, bent over a spiral notebook, pencil grasped in a white-knuckled fist, attacking the paper so forcefully Lola feared she’d shred it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Algebra,” Ruthie said when Margaret failed to answer. “She catches on fast.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola stopped herself before she made a face. Because despite the fact that it had defeated her in high school, learning algebra was a good thing, right? The kind of thing the aunties would like to know she supported.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola leaned over Margaret, aiming a kiss at her cheek. “Let’s see these algebra problems.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Margaret jerked her face out of reach, snatched at the paper, balled it in her fist, and threw it across the room. Ruthie caught her breath and headed for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola dropped the take-out bag on the table, extracted foil-wrapped paper plates, and raised her voice, knowing that part of Ruthie’s job involved reporting back to the aunties. “Mmmm. Meatloaf and mashed potatoes. Nell’s special today. And green beans. So we get our vegetables.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ruthie never would slam the door. But the exaggerated care she took in shutting it conveyed skepticism as effective as any teenage eye roll.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How about setting the table?” Lola spoke to the top of Margaret’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t need to. Nell always puts plastic in.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So that’s how it was going to be. Lola pushed one of the plates toward her—along with the plastic utensils from, as predicted, the bottom of the bag—went to the sink, ran tap water into two glasses, and returned. She peeled back the foil from the plates. Steam boiled up, wafting the homey scent of warm meat and gravy that filled the space conversation might otherwise have occupied. Margaret, after the first few bites, pushed her food around on her plate, dragging her fork through the mound of mashed potatoes so that the pool of gravy broke free, flowing across the plate in the four precise streams mandated by the tines, puddling against the generous square of meatloaf. Then, in flagrant violation of the rules, she put her plate on the floor and flounced wordlessly away as Bub dispatched the meatloaf with the same ferocity he’d have turned on a prairie dog, if only he could catch one.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hey!”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Margaret, who had no compunction about slamming the door, was already gone. Bub cast a longing look at the closed door. Lola rated only a sidelong gaze, a once-over from his accusing eyes, one brown, one blue, before he heaved an aggrieved sigh and settled himself in a far corner, head on his paws, keeping her in sight, but removing himself in a pointed rebuke.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Fine.” Two could play that game. Lola left her own plate on the table and settled herself on the sofa, pen and notebook in hand and a goal in mind—to come up with a rejection of Jan’s offer, one that would survive Alice Kicking Woman’s gimlet-eyed scrutiny. She’d make bullet points. Memorize them. Practice her delivery. Her pen hovered over the blank page. Movement caught her eye.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Through the window, she saw Margaret perched on the corral fence, calling to Spot. The horse who’d so flagrantly ignored Lola not an hour before lifted his head, swiveled his ears forward, and trotted toward Margaret, scattered the chickens scratching around the fenceposts. Margaret’s flock of intermittently egg-laying hens reveled in their final hours of freedom before being locked away in their coop for the night, safe from prowling foxes and coyotes and, more recently in the region, the grizzly bears increasingly on the move out of the nearby mountains and onto the plains, where to their delight ranches offered up a buffet of fat calves and sheep and even squawking chickens. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As Lola watched, Margaret slid from the fence onto Spot’s bare back. She thumped her heels against his flanks. Spot ambled back across the corral. Margaret drummed her feet more insistently, heels a blur. Spot broke into a jolting trot, then a canter, wheeling as he reached the fence, Margaret balancing effortlessly through the turn, reaching back with one hand to whack his rear, Spot in full gallop now, around and around the corral, the girl bent low over his neck, a hand wrapped in his mane, trying to outrun her misery.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The pen fell from Lola’s hand. She looked away, lay the notebook aside. Dug in her pocket for one of the pills she’d filched from Lena. Swallowed dry. Her list could wait.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The alarm sounded different, something beyond its usual beep-beep-beep. Which was faint, farther away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola rolled over into space. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When she opened her eyes after the thud, she was on the floor beside the couch, Bub looming above her, his barking nearly drowning out the beeping from the bedroom, along with that other sound—an unholy banging—from the front door. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola was sure she’d had worse awakenings. Hangovers. Wrong bed, wrong person. This, though. It ranked right up there.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bub, satisfied her eyes were open, turned his full attention upon the door, dialing up the volume on his barking. Whoever was on the other side responded in kind. The door shook in its frame. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Blam. Blam. Blam")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Somehow Lola was on her feet. Staggering toward the door, skating her tongue across her teeth, scrubbing at her eyes with the heel of her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” She jerked the door open. “Oh. Amanda. Hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Amanda Richards took a step back and hugged her clipboard to her chest. “Hey, Lola. Take it easy, Bub. It’s just me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bub stopped in mid-bark and accorded Amanda a single swish of his feathery tail, an acknowledgment of acquaintance, if not actual friendship. Amanda was the region’s social worker, stationed at a Department of Public Health and Human Services satellite office in a nearby town, and had worked the occasional case with Charlie. She had her profession’s efficient short haircut and indestructible shoes, along with the poker face born of thirty years of walking into unsettling situations.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Something was off today, though. Lola blinked and tried to focus. The suit. That was it. Lola couldn’t remember the last time she’d seen someone in Magpie wearing a suit, even at a funeral, but Amanda stood before her in a burgundy number, probably something grabbed off the rack at the J.C. Penney store in Great Falls, a little too big, Amanda’s hands disappearing into the sleeves, the skirt bagging. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You going to a funeral, Amanda?” Lola couldn’t remember any recent deaths of note in Magpie, but maybe Amanda had family in one of the outlying towns. Even though nobody really wore suits to funerals. Clean jeans and a pressed shirt usually sufficed.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Something about the way she said it forced Lola to meet Amanda’s clear-eyed gaze that betrayed nothing beyond a certain intensity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Lola, this is business. May I come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola stood aside. “Did we have an interview scheduled? If we did, I’m sorry. I must have spaced it.” Her all-purpose excuse these days. She tried to remember why she was supposed to talk with Amanda this time. She occasionally called upon her for quotes to shore up a story, usually about child abuse or neglect, both on the rise apace with a meth problem bedeviling Montana anew after a brief crackdown that only allowed pills to take hold. “Law Enforcement Whack-A-Mole,” Charlie called the cops’ always-a-step-behind attempts to keep up with all the ways people tried to escape reality.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We didn’t have an appointment.” Amanda stopped in the middle of the room. “Is Margaret here?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Was she? Amanda’s nostrils flared at Lola’s hesitation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola rolled the dice. “She’s still asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Lola. It’s nearly noon. Where’s Margaret?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Too late, Lola came awake, alertness rushing in like the wind off the Front, icy with imminent danger. The stillness of the house somehow louder than the alarm’ beep-beep-beep. Bub stood frozen, hackles lifting. He felt it, too. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Margaret had gotten herself off to school again, this time without bothering to wake Lola. Amanda’s gaze swept the room. Too late, Lola saw it as she did—Margaret’s paper plate on the floor, licked clean of the previous night’s dinner, unlike Lola’s, which still sat on the table, the congealed remnants of meatloaf, the gravy skinned over, potatoes gone yellow and crusted. The water glasses, their rims smeary. A fly, who’d somehow sneaked inside to escape the coming winter, paddled in exhausted circles in one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The beeping alarm, on and on.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nearly noon, Amanda had said. The alarm had been set for six-thirty. Damn. Lena’s pills were "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("strong")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Amanda followed the beeping into Lola’s bedroom, the sudden silence worse than the alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Amanda returned, situating herself at the precarious edge of the sofa, a cautious perch that minimized contact with God knows what in the way of microbes, and that positioned her to flee if things went south. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The winds of fear howled in Lola’s ears, nearly drowning out Amanda’s words.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’d better sit down.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola’s hands shook so hard that she punched the wrong setting for Jan’s number. She managed to click off, then tried again.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jan picked up without saying anything. Just waited, the dead air more judgmental than any lecture.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That story. The one in Utah. It doesn’t sound so bad.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Uh-huh.” Disbelief radiated through the ether.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Amanda’s words looped through Lola’s brain, a backbeat to the dead-dead-dead refrain. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There’s been a complaint. Confidential. We’ve launched an investigation. It’s mandatory. I’ll need to schedule an appointment to see you and Margaret for an evaluation. Together—and separately, too")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Was it you?’ Lola wanted to ask now. “Did you call in the complaint?”"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }), _vm._v("Because she wouldn’t have put it past Jan, forcing her hand, making her take the assignment. Even Jan might have balked at such drastic action, though. It was one thing for the aunties to talk of taking in Margaret, in the casual way that kids on the rez were fostered by friends and relatives when parents went astray. But to involve the state was to pose the risk that something inexorable would grind into action, that Margaret might be taken away and never returned, might end up with people who despite their outward seemliness would view her as little more than a maid or a nanny for their other children; worse yet, a home where the husband prowled the halls at night, slipping into the room of a girl whose accusations would crumble beneath the weight of his unimpeachable standing in the community. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The aunties’ ultimatum had pissed her off. This, though—this was terrifying.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When can you leave?” Jan, thinking she was calling her bluff.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As soon as possible.” Lola spoke over reverberation of her conversation with Amanda, echoing endlessly in her mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("An evaluation?")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To determine whether this is a case that justifies removal.")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Removal? What are you talking about?")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Please, Lola. You know what it means")]), _vm._v(". "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The good of the child is paramount.")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tomorrow,” she told Jan. “Tonight, even.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She hung up and reached for the business card Amanda had left. Amanda had written her cell on the back, along with the appointment information, two days hence at four in the afternoon, so as not to interrupt Margaret’s school day.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola dialed the office line. The drive took nearly an hour. Amanda wouldn’t be back yet. She waited for the voicemail prompt.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Amanda, this is Lola. That appointment. We’ll have to cancel. I’ve got an out-of-town assignment. You can ask Jan. I’ll reschedule when I get back.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She clicked the phone off and flung it away.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Like hell I will.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3931caf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504084826-2.vue
// module id = 78
// module chunks = 0